import MobxReactForm from 'mobx-react-form';

/**
 * @class
 * @extends {MobxReactForm}
 * @param {Object} fields
 * @param {Object} options
 */
export class Form extends MobxReactForm {
  options() {
    return {
      validationDebounceWait: 0,
      validationDebounceOptions: {
        leading: true
      },
      validateOnChange: true,
      validateOnReset: true,
      showErrorsOnReset: false
    };
  }
}
